<template>
  <div
    class="card card-vertical offer-card"
    :data-title="oferta.ofr.obj.name"
    itemprop="offers"
    itemscope="1"
    itemtype="http://schema.org/Event"
  >
    <meta itemprop="name" :content="oferta.ofr.obj.name" />
    <meta
      itemprop="startDate"
      :content="formatDataSchema(oferta.ofr.trp.startDate)"
    />
    <meta
      itemprop="endDate"
      :content="formatDataSchema(oferta.ofr.trp.rDesDate)"
    />
    <div class="offer-card__image-wrapper">
      <div class="card__discount" v-if="getDiscountPercentage(oferta) > 5">
        <span class="badge badge_discount">-{{ discount }}%</span>
      </div>
      <div class="offer-card__clipboard">
        <a
          class="clipboard-btn"
          :hhref="getUrlSchowka(oferta)"
          href="javascript:void(0);"
          :title="getSchowekTitle(oferta)"
          @click="doClickSchowek(oferta)"
        >
          <span :class="getBtnClass(oferta)">
            <svg
              class="svg-icon__svg"
              :width="22"
              :height="22"
              focusable="false"
            >
              <use v-bind:xlink:href="getBtnSvg(oferta)"></use>
            </svg>
          </span>
        </a>
      </div>

      <div class="offer-card__thumbs-slider">
        <splide
          ref="offerCardSlider"
          :key="componentKey"
          :options="primaryOptions"
        >
          <splide-slide v-for="(slide, idx) in slides" :key="idx">
            <div
              :class="{ '__before-loaded': !isLoaded }"
              class="card__thumbnail offer-card__thumbnail"
            >
              <img
                :data-splide-lazy="slide"
                alt=""
                class=""
                @error="onImgError"
                @load="onImgLoad"
                @click="goToOffer(oferta)"
              />
            </div>
          </splide-slide>
        </splide>
      </div>
    </div>
    <div class="card__content relative">
      <span
        itemprop="location"
        itemscope="1"
        itemtype="http://schema.org/Place"
      >
        <div class="mb-12">
          <meta
            itemprop="name"
            :content="getCountryAndRegionFromOferta(oferta)"
          />
          <div class="card__regions">
            <template
              v-if="
                getUrlLocid(oferta) == '' ||
                getDomainType('travelone', 'skione')
              "
            >
              <T1CardBreadcrumbs :items="getBreadcrumbs(oferta)" />
            </template>
            <template v-else>
              <!-- Nie ma sensu dołączać wszystkich geostruktur państw -->
              <T1CardBreadcrumbs :locid="getUrlLocid(oferta)" />
              <!-- <T1CardBreadcrumbs :items="getBreadcrumbs(oferta)" /> -->
            </template>
          </div>

          <h3 class="card__hotel-name font-20 mb-2">
            <a :href="getUrlOferta(oferta)" :title="oferta.ofr.obj.name">{{
              oferta.ofr.obj.name
            }}</a>
          </h3>
          <T1Stars class="card__category" :number="oferta.ofr.obj.category" />
        </div>
      </span>
      <div
        class="offer-card__content"
        itemprop="offers"
        itemscope="1"
        itemtype="http://schema.org/Offer"
      >
        <meta itemprop="price" :content="oferta.ofr.price" />
        <meta itemprop="priceCurrency" content="PLN" />
        <meta itemprop="url" :content="getUrlOferta(oferta)" />
        <link
          style="display: none"
          itemprop="availability"
          href="http://schema.org/InStock"
        />
        <meta
          itemprop="validFrom"
          :content="formatDataSchema(oferta.ofr.trp.startDate)"
        />
        <T1TripDetails
          :dateFrom="formatData(oferta.ofr.trp.startDate)"
          :dateTo="formatData(oferta.ofr.trp.rDesDate)"
          :depDesc="oferta.ofr.trp.depDesc"
          :duration="oferta.ofr.trp.duration"
          :service="getWyzywienie(oferta.ofr.obj.xServiceId)"
          :touropName="getTourop(oferta.ofr.tourOp)"
          :type="oferta.ofr.type"
          class="mb-12"
          iconSize="14"
        />
        <div class="offer-card__price">
          <div
            class="mr-8 font-14 gray-30 text-crossed"
            v-if="getDiscountPercentage(oferta) > 5"
          >
            {{ getMaxPrice(oferta) }} zł/os.
          </div>
          <span>
            od: <span class="font-24">{{ oferta.ofr.price }}</span> zł/os.
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { tourop } from "../tourops.js";
import { wyzywienie } from "../wyzywienie.js";
import { domains } from "../domains.js";
import T1Stars from "../T1Shared/T1Stars";
import T1TripDetails from "./T1TripDetails";
import T1CardBreadcrumbs from "../T1Breadcrumbs/T1CardBreadcrumbs";
import * as GEOSTRUCTURE from "../../../geotree.js";
import { domainTypeMixin } from "@/mixins/domainTypeMixin";

axios.defaults.withCredentials = false;

export default {
  mixins: [domainTypeMixin],
  name: "results-offer-card",
  props: {
    oferta: [Array, Object],
    schowek: [Array, Object],
    isLoading: Boolean,
  },
  data: () => ({
    tourop: tourop.tourops,
    wyzyw: wyzywienie.wyz,
    geostruct: GEOSTRUCTURE.geostruktura,
    domeny: domains.countries,
    isLoaded: false,
    primaryOptions: {
      drag: true,
      type: "slide",
      lazyLoad: "nearby",
      preloadPages: 2,
      pagination: false,
    },
    defaultImage: "https://www.travelone.pl/newimgs/zaslepka_lato.jpg",
    componentKey: 0,
    slides: [],
    air: true,
    TIMEOUT_ms: 15000
  }),
  methods: {
    getPics(tourop, htlcode) {
      var that = this;
      var pars = "tourop=" + tourop + "&htlcode=" + htlcode;
      return axios
        .get("https://cdn.travelone.pl/rest/vue2api/getpics.xml" + "?" + pars, null, {
          signal: that.newAbortSignal(that.TIMEOUT_ms),
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          if (response.data && response.data != null) {
                return response.data;
          } else {
                //this.slides=[this.defaultImage];
                return null;
          }
        })
        .catch((e) => {
          console.log("ERROR" + e);
          //this.slides=[this.defaultImage];
          return null;
        });
    },
    getCountryAndRegionFromOferta(oferta) {
      return oferta.ofr.obj.country + " > " + oferta.ofr.obj.region;
    },
    getSlides() {
      this.slides = [];
      const offer = this.oferta.ofr;
      let tourOpCode = "";
      let context = "";
      let season = "";
      let imagesArr = [];
      let slidesCount = 8;

      if (offer) {
        if (offer.trp.season == 4) {
          season = "W";
        } else {
          season = "S";
        }

        if (
          (offer.tourOp == "WYGO" || offer.tourOp == "TUIZ") &&
          season == "W"
        ) {
          context = "winter/";
        }

        if (
          (offer.tourOp == "WYGO" || offer.tourOp == "TUIZ") &&
          season == "S"
        ) {
          context = "sommer/";
        }

        if (
          offer.tourOp == "ITAG" ||
          offer.tourOp == "VITX" ||
          offer.tourOp == "VITG"
        ) {
          tourOpCode = "ITAK";
        } else if (offer.tourOp == "ECTR") {
          tourOpCode = "ECCO";
        } else {
          tourOpCode = offer.tourOp;
        }

	try { 
		if (offer.tourOp != "XYOB") {

                var that = this;
                this.getPics(offer.tourOp, offer.obj.code).then((data) => {
                        if (data && data!=null && data.images) {
                                let pics = data.images;
                                that.slides = [];

                                if (pics && pics != null && pics.length > 0) {
                                        pics.forEach( (elem) => that.slides.push(elem.url) );
                                } else {
                                        //that.slides = [that.defaultImage];
                                }
                        } else {
                                //that.slides = [that.defaultImage];
                        }
                }).catch(e => {
                        console.log("Error in getPics:" + e);
                        //that.slides = [that.defaultImage];
                }).finally( () => {
                        if (this.slides && this.slides.length < 1) {
                                this.slides = [this.defaultImage];
                        }
                });
                } else {
                        //console.log("XYOB found." + offer.datagourl);
                        this.primaryOptions.drag = false;

                        if (offer.datagourl && offer.datagourl != "") {
                                this.slides = [
                                        "https://" + offer.datagourl.replace(/T320/i, "T640"),
                                ];
                        } else {
                                this.slides = [this.defaultImage];
                        }
                }

        } catch(e) {
                console.log("ERROR: " + e);
                //this.slides = [this.defaultImage];
        } finally {
        }

      }
    },
    forceRerender() {
      this.componentKey += 1;
    },
    goToOffer(oferta) {
      let urltogo = this.getUrlOferta(oferta);
      if (urltogo != null && urltogo.indexOf("www") !== -1) {
        window.location = this.getUrlOferta(oferta);
      } else {
        this.$router.push(urltogo);
        window.scrollTo(0, 0);
      }
    },
    onImgLoad() {
      this.isLoaded = true;
    },
    onImgError(e) {
      e.target.src = this.defaultImage;
      this.isLoaded = true;
    },
    getBreadcrumbs(oferta) {
      let crumbsArr = [];

      if (
        (oferta.ofr.obj.type != "R" &&
          oferta.ofr.obj.region != "Wyc. objazdowe") ||
        oferta.ofr.obj.xCity != "Wyc. objazdowe"
      ) {
        if (typeof oferta.ofr.obj.country === "string") {
          crumbsArr.push({ name: oferta.ofr.obj.country, link: "" });
        }
        if (typeof oferta.ofr.obj.region === "string") {
          crumbsArr.push({ name: oferta.ofr.obj.region, link: "" });
        }
        if (
          typeof oferta.ofr.obj.xCity === "string" &&
          oferta.ofr.obj.xCity != oferta.ofr.obj.region
        ) {
          crumbsArr.push({ name: oferta.ofr.obj.xCity, link: "" });
        }
      } else {
        crumbsArr.push({
          name: oferta.ofr.obj.country + ": wycieczki objazdowe",
          link: "",
        });
      }
      return crumbsArr;
    },
    formatData(data) {
      if (data != "" && data.length >= 8) {
        return (
          data.substring(6) +
          "." +
          data.substring(4, 6) +
          "." +
          data.substring(0, 4)
        );
      } else {
        return "";
      }
    },
    formatDataSchema(data) {
      if (data != "" && data.length >= 8) {
        return (
          data.substring(0, 4) +
          "-" +
          data.substring(4, 6) +
          "-" +
          data.substring(6)
        );
      } else {
        return "";
      }
    },
    getUrl(oferta) {
      if (
        oferta.ofr &&
        oferta.ofr.datagourl !== undefined &&
        oferta.ofr.datagourl != ""
      ) {
        return "https://" + oferta.ofr.datagourl.replace(/T320/i, "T640");
      } else {
        let kontekst = "";
        let season = "";
        let tourOpfix = "";
        if (oferta.ofr.trp.season == 4) {
          season = "W";
        } else {
          season = "S";
        }
        if (
          (oferta.ofr.tourOp == "NPL" ||
            oferta.ofr.tourOp == "HIT" ||
            oferta.ofr.tourOp == "WYGO" ||
            oferta.ofr.tourOp == "TUIZ") &&
          season == "W"
        ) {
          kontekst = "winter/";
        }
        if (
          (oferta.ofr.tourOp == "NPL" ||
            oferta.ofr.tourOp == "HIT" ||
            oferta.ofr.tourOp == "WYGO" ||
            oferta.ofr.tourOp == "TUIZ") &&
          season == "S"
        ) {
          kontekst = "sommer/";
        }
        if (oferta.ofr.tourOp == "HIT") {
          tourOpfix = "NPL";
        } else if (
          oferta.ofr.tourOp == "ITAG" ||
          oferta.ofr.tourOp == "VITX" ||
          oferta.ofr.tourOp == "VITG"
        ) {
          tourOpfix = "ITAK";
        } else if (oferta.ofr.tourOp == "ECTR") {
          tourOpfix = "ECCO";
        } else {
          tourOpfix = oferta.ofr.tourOp;
        }
        return (
          "https://data2.merlinx.pl/" +
          tourOpfix +
          "/" +
          kontekst +
          tourOpfix +
          "-" +
          oferta.ofr.obj.code +
          "-0.jpg"
        );
      }
    },
    getFromDate(data) {
      if (data != null && data != "" && data.length >= 8) {
        return data.substring(4, 6) + data.substring(6);
      } else {
        return "";
      }
    },
    doClickSchowek(oferta) {
      var url = this.getUrlSchowka(oferta);
      if (this.schowek instanceof Array) {
        this.schowek.push(oferta.ofr.id);
      } else {
        this.schowek = oferta.ofr.id;
      }
      if (window.localStorage && localStorage.getItem("t1uid")) {
        var offers = localStorage.getItem("t1offers").split(",");
        offers.push(oferta.ofr.id);
        localStorage.setItem("t1offers", offers);
      }
      localStorage.setItem("t1needsync", 1);
      location.href = url;
      return false;
    },
    getSchowekTitle(oferta) {
      return "Dodaj do schowka ofertę hotelu: " + oferta.ofr.obj.name;
    },
    getBtnSvg(oferta) {
      if (this.schowek instanceof Array) {
        return this.schowek.includes(oferta.ofr.id)
          ? "/img/static/svg-sprites.svg#icon-heart-full"
          : "/img/static/svg-sprites.svg#icon-heart-o";
      } else {
        return this.schowek === oferta.ofr.id
          ? "/img/static/svg-sprites.svg#icon-heart-full"
          : "/img/static/svg-sprites.svg#icon-heart-o";
      }
    },
    getBtnClass(oferta) {
      if (this.schowek instanceof Array) {
        return this.schowek.includes(oferta.ofr.id)
          ? "clipboard-btn__iconschowek"
          : "clipboard-btn__icon";
      } else {
        return this.schowek === oferta.ofr.id
          ? "clipboard-btn__iconschowek"
          : "clipboard-btn__icon";
      }
    },
    getUrlSchowka(oferta) {
      let lparams = this.$route.query;
      let adt = 2;
      if (lparams["adt"]) {
        adt = Number(lparams["adt"]);
      }
      return (
        "https://www.travelone.pl/oferta/schowek.xml?oper=add&" +
        this.getUrlOfertaCommonParams(oferta) +
        "&turnus=1"
      );
    },
    getUrlContext(oferta) {
      if (oferta.ofr.hurl != "") {
        return oferta.ofr.hurl + "?";
      } else {
        return "/hotele/hotel.xml?";
      }
    },
    getUrlLocid(oferta) {
      if (oferta.ofr.hlocid != "") {
        return oferta.ofr.hlocid;
      } else {
        return "";
      }
    },
    getUrlDomena(oferta) {
      let ocountry = oferta.ofr.obj.country;
      if (ocountry != null && typeof ocountry === "string") {
        let lcountry = ocountry
          .replace(/\s+/g, "")
          .replace(/ą/g, "a")
          .replace(/ę/g, "e")
          .replace(/ś/g, "s")
          .replace(/ć/g, "c")
          .replace(/ń/g, "n")
          .replace(/ż/g, "z")
          .replace(/ź/g, "z")
          .replace(/ó/g, "o")
          .replace(/ł/g, "l")
          .replace(/Ą/g, "a")
          .replace(/Ę/g, "e")
          .replace(/Ś/g, "s")
          .replace(/Ć/g, "c")
          .replace(/Ń/g, "n")
          .replace(/Ż/g, "z")
          .replace(/Ź/g, "z")
          .replace(/Ó/g, "o")
          .replace(/Ł/g, "l")
          .toLowerCase();
        let elems = this.domeny.filter((e) => e.nazwa === lcountry);
        if (elems.length > 0) {
          return "https:\/\/www." + elems[0].domena;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    getUrlOferta(oferta) {
      return (
        this.getUrlDomena(oferta) +
        this.getUrlContext(oferta) +
        this.getUrlOfertaCommonParams(oferta)
      );
    },
    getUrlOfertaCommonParams(oferta) {
      let lparams = this.$route.query;
      let adt = 2;
      let chd = 0;
      let inf = 0;
      let chage = "";
      if (lparams["adt"]) {
        adt = Number(lparams["adt"]);
      }
      if (lparams["chd"]) {
        chd = Number(lparams["chd"]);
      }
      if (lparams["inf"]) {
        inf = Number(lparams["inf"]);
      }
      if (lparams["chage"]) {
        chage = lparams["chage"];
      }
      //let link = 'https://www.wyspykanaryjskie.pl/merlinobiektmds-param.xml?xCode=' + oferta.ofr.obj.xCode + '&tourOp=' + oferta.ofr.tourOp + '&htlCode=' + oferta.ofr.obj.code + '&kodId=' + oferta.ofr.id;
      //let link = '/#/hotele/hotel.xml?xCode=' + oferta.ofr.obj.xCode + '&tourOp=' + oferta.ofr.tourOp + '&htlCode=' + oferta.ofr.obj.code + '&kodId=' + oferta.ofr.id;
      //let link = '/hotele/hotel.xml?xCode=' + oferta.ofr.obj.xCode + '&tourOp=' + oferta.ofr.tourOp + '&htlCode=' + oferta.ofr.obj.code + '&kodId=' + oferta.ofr.id;
      let link =
        "xCode=" +
        oferta.ofr.obj.xCode +
        "&tourOp=" +
        oferta.ofr.tourOp +
        "&htlCode=" +
        oferta.ofr.obj.code +
        "&kodId=" +
        oferta.ofr.id;
      link += "&adt=" + adt;
      if (chd > 0) {
        link += "&chd=" + chd;
      }
      if (chage != "") {
        link += "&chage=" + chage;
      }
      if (inf > 0) {
        link += "&inf=" + inf;
      }
      let fromDate = this.getFromDate(oferta.ofr.trp.startDate);
      if (fromDate != "") {
        link += "&fromDate=" + fromDate;
      }
      return link;
    },
    getWyzywienie(numer) {
      return this.wyzyw[numer];
    },
    getTourop(tourop) {
      let tourOpName;
      if (tourop != null && tourop != "") {
        let items = this.tourop;
        items.forEach(function (obj) {
          if (obj.kod == tourop) {
            tourOpName = obj.nazwa;
          }
        });
        return tourOpName;
      } else {
        return "";
      }
    },
    getStars(oferta) {
      return "five-stars stars-" + oferta.ofr.obj.category;
    },
    imgUrlAlt(event) {
      //console.log(event);
      event.target.src =
        "https://www.travelone.pl/newimgs/zaslepka_lato_zest.jpg";
    },
    getDiscount(x, y) {
      return 100 - (x * 100) / y;
    },
    getMaxPrice(oferta) {
      if (
        oferta.ofr.extra &&
        oferta.ofr.extra.priceHistory &&
        oferta.ofr.extra.priceHistory.max
      ) {
        this.maxprice = oferta.ofr.extra.priceHistory.max;
      }
      return this.maxprice;
    },
    getDiscountPercentage(oferta) {
      if (
        oferta.ofr.extra &&
        oferta.ofr.extra.priceHistory &&
        oferta.ofr.extra.priceHistory.max
      ) {
        let price = oferta.ofr.price;
        let maxprice = oferta.ofr.extra.priceHistory.max;
        if (maxprice != price) {
          this.discount = Math.floor(
            this.getDiscount(Number(price), Number(maxprice))
          );
          return this.discount;
        }
      }
    },
    newAbortSignal(timeoutMs) {
        var that = this;
        // that.$forceUpdate();
        const abortController = new AbortController();
            setTimeout(() => {
                if (that.slides.length < 1) {
                   that.slides = [that.defaultImage];
                }
                abortController.abort();
            }, timeoutMs || 0);

        return abortController.signal;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getSlides();
    });
  },
  watch: {
    oferta: function () {
      this.getSlides();
    },
    slides: function () {
      this.forceRerender();
    },
  },
  components: {
    T1Stars,
    T1TripDetails,
    T1CardBreadcrumbs,
  },
};
</script>

<style lang="scss" scoped>
@import "@/components/T1OfferCards/T1CardCommonStyles";
.offer-card {
  &__thumbs-slider {
    position: relative;
    width: 100%;
    height: 100%;

    &::before {
      border-color: $border-color;
      border-radius: 3px 3px 0 0;
      border-style: solid;
      border-width: 1px 1px 0;
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: absolute;
    }
  }

  &__thumbnail {
    background-color: $gray-00;
    height: 55vw;

    @media (min-width: $screen-xxs) {
      height: 50vw;
    }

    @media (min-width: $screen-xs) {
      height: 26vw;
    }

    @media (min-width: $screen-md) {
      height: 200px;
    }

    @media (min-width: $screen-lg) {
      height: 220px;
    }

    > img {
      cursor: pointer;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  &__price {
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    line-height: 1.1;
    margin-top: auto;
  }

  &__clipboard {
    position: absolute;
    right: 8px;
    top: 8px;
    z-index: 2;
  }
}

::v-deep .offer-card {
  &__thumbs-slider {
    .splide__arrow {
      background-color: transparent;

      svg {
        fill: #fff;
      }

      &:disabled {
        display: none;
      }
    }

    .splide__arrow--prev {
      left: 12px;
    }

    .splide__arrow--next {
      right: 12px;
    }

    .splide__spinner {
      border-color: $blue-light;
      border-left-color: transparent;
      z-index: 2;
    }
  }
}

.clipboard-btn {
  background-color: rgba(#000, 0.45);
  border-radius: 2px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 36px;
  opacity: 0.75;
  transition: all ease-in-out 0.15s;

  &:hover {
    color: #ff2516;
    background-color: rgba(#000, 0.75);
  }

  &__iconschowek {
    color: #ff2516;
    display: flex;
  }

  &__icon {
    display: flex;
  }
}
</style>
